import { Types } from "@grandvisionhq/graphql";
import { isDefined, getLocalizedString, isNumber } from "@grandvisionhq/utils";
import { createProductTypeName } from "../../utils/utils/create-product-type-name.js";
import { getConsolidationFacet } from "../../utils/utils/get-consolidation-facet.js";
import { getDiscount } from "../../utils/utils/get-discount.js";
const mapGraphProductToVisualListingProduct = (product, intl) => {
  const { locale } = intl;
  const slug = product.slug;
  const productType = createProductTypeName(product.productType);
  if (!slug || !productType || !product.variants || product.variants.length === 0) {
    console.error(
      "No slug, objectId, productType or variants found for product slug: ",
      product.slug
    );
    return void 0;
  }
  const masterVariant = mapVariant(product, product.variants[0], locale);
  if (!masterVariant) {
    console.error("No variants found for product slug: ", product.slug);
    return void 0;
  }
  const otherVariants = product.variants.slice(1).map((variant) => mapVariant(product, variant, locale)).filter(isDefined);
  const localizedName = getLocalizedString(product.nameAllLocales, locale);
  return {
    masterVariant,
    name: {
      en: product.name,
      localized: localizedName
    },
    productType,
    slug,
    variants: otherVariants
  };
};
const mapVariant = (product, variant, locale) => {
  const images = variant.media.images.map((img) => ({
    url: img.url,
    label: img.label || "",
    altTag: "",
    dimensions: {
      w: img.dimensions.w,
      h: img.dimensions.h
    }
  }));
  const prices = variant.priceList.find(
    (priceListItem) => priceListItem.priceType === Types.ProductPriceItemType.SINGLE_PURCHASE
  );
  if (!prices || !prices.originalPrice) {
    console.error("No prices found for product sku: ", variant.sku);
    return void 0;
  }
  const consolidationFacet = getConsolidationFacet(variant);
  return {
    brand: {
      name: product.brand
    },
    description: variant.description || "",
    name: variant.displayName,
    sku: variant.sku,
    tag: variant.tags?.[0] ? {
      key: variant.tags[0].key,
      value: variant.tags[0].value
    } : void 0,
    images,
    pricing: {
      // Best price is returned as a cent amount, but the other prices are floats, therefore, we transform it into a decimal
      bestPrice: isNumber(variant.bestPrice) ? variant.bestPrice / 100 : void 0,
      price: {
        isCentAmount: false,
        originalPrice: prices.originalPrice.amount,
        currencyCode: prices.originalPrice.currencyCode,
        discount: prices.discountedPrice?.price?.amount ? {
          price: prices.discountedPrice.price?.amount,
          badge: getDiscount(
            locale,
            prices.discountedPrice?.price?.currencyCode,
            prices.discountedPrice?.discountInformation?.type ?? void 0,
            prices.discountedPrice?.discountInformation?.value ?? void 0
          ),
          description: prices.discountedPrice.discountInformation?.description?.[0]?.value
        } : void 0
      },
      pricePerUnit: {
        amount: prices.pricePerUnit?.amount,
        currencyCode: prices.pricePerUnit?.currencyCode
      }
    },
    isInsuranceReimbursable: variant.__typename === "FrameVariant" && variant.variantTypeDetails.isInsuranceReimbursable,
    replacementFrequency: product.__typename === "ContactLensProduct" ? getLocalizedString(product.productTypeDetails.replacementFrequencyAllLocales, locale) : void 0,
    contactLensCareType: variant.__typename === "SolutionVariant" ? variant.variantTypeDetails.contactLensCareType || void 0 : void 0,
    packageOption: variant.__typename === "SolutionVariant" ? `${variant.variantTypeDetails.volume}${variant.variantTypeDetails.volumeUnit}` : void 0,
    consolidationFacet
  };
};
export {
  mapGraphProductToVisualListingProduct,
  mapVariant
};
//# sourceMappingURL=map-graph-product-to-visual-listing-product.js.map
